import { LoginUserRole } from "../signup/UserRole";
import { GroupUser } from "../../bookone-admin/group";
import { UserRole } from "../../bookone-admin/user-role";
import { Address } from "app/views/bookone/address";
export class ApplicationUser {
  id: number;
  businessName: string;
  address: Address;
  email: string;
  logoUrl: string;
  confirmEmail: string;
  password: string;
  uuid: string;
  resetStatus: boolean;
  passwordResetLink: string;
  confirmPassword: string;
  username: string;
  mobileNumber: string;
  landphoneNumber: string;
  maxBookingDiscountPercentage: number;
  maxOrderDiscountPercentage: number;
  firstName: string; // firstname
  lastName: string; // lastname
  pin: number;
  roles: Array<LoginUserRole>;
  properties: Array<GroupUser>;
  constructor() {}
}
